// Static legal copy for Wholesome 360.
// This is descriptive placeholder content the client can refine with counsel
// before launch.

export const PRIVACY = {
  title: 'Privacy Policy',
  updated: 'Effective July 2025',
  sections: [
    {
      heading: 'What we collect',
      body: [
        'When you place a catering order or request a Fridge Program quote, we collect your name, email, phone number, company (if provided), delivery address, event date and any dietary notes you share.',
        'We also collect basic technical information such as your IP address and browser type through standard server logs.',
      ],
    },
    {
      heading: 'How we use it',
      body: [
        'We use your information to fulfill your order, coordinate delivery and setup, follow up about your event, and respond to Fridge Program inquiries.',
        'We do not sell your personal data. We do not send marketing emails unless you opt in.',
      ],
    },
    {
      heading: 'Who we share it with',
      body: [
        'We share information only with service providers who help us run our business (payment processors, delivery drivers, IT hosts) and only to the extent needed to deliver your order. We may disclose information when required by law.',
      ],
    },
    {
      heading: 'Data retention',
      body: [
        'Order and lead records are retained for 7 years for tax and accounting purposes and then deleted. You may request deletion of your data at any time by emailing info@wholesome360.com.',
      ],
    },
    {
      heading: 'Contact us',
      body: [
        'Questions about this policy? Email info@wholesome360.com or call 773-857-0230.',
      ],
    },
  ],
};

export const TERMS = {
  title: 'Terms of Service',
  updated: 'Effective July 2025',
  sections: [
    {
      heading: 'Ordering',
      body: [
        'Catering orders require 24 hours’ advance notice and a $300 minimum. Free delivery and setup are included on all catering orders.',
        'By placing an order you confirm that all information provided is accurate.',
      ],
    },
    {
      heading: 'Cancellations & changes',
      body: [
        'Orders may be modified or cancelled at no charge up to 24 hours before the scheduled delivery time. Cancellations within 24 hours may be subject to a 50% fee to cover ingredient and labor costs.',
      ],
    },
    {
      heading: 'Delivery',
      body: [
        'We deliver within a 20-mile radius of West Town, Chicago (60612). Free delivery, including setup service, is included on all catering orders.',
        'Please ensure someone is available to receive the delivery at the scheduled time.',
      ],
    },
    {
      heading: 'Fridge Program',
      body: [
        'Wholesome 360 provides the commercial-grade fridge, restocks it 2–3 times per week, and handles all cleaning and maintenance. Fridge Program contracts are billed weekly and can be paused with 14 days’ notice.',
      ],
    },
    {
      heading: 'Allergens',
      body: [
        'Our kitchen handles nuts, dairy, gluten, eggs and sesame. While we do our best to accommodate dietary restrictions, we cannot guarantee an allergen-free preparation environment. Guests with severe allergies should exercise their own judgment.',
      ],
    },
    {
      heading: 'Limitation of liability',
      body: [
        'To the extent permitted by law, Wholesome 360’s liability for any claim relating to an order is limited to the amount paid for that order.',
      ],
    },
  ],
};

export const ACCESSIBILITY = {
  title: 'Accessibility Statement',
  updated: 'Effective July 2025',
  sections: [
    {
      heading: 'Our commitment',
      body: [
        'Wholesome 360 is committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply the relevant accessibility standards.',
      ],
    },
    {
      heading: 'Standards',
      body: [
        'This site aims to conform with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. That means our content is designed to be perceivable, operable, understandable and robust across a wide range of assistive technologies.',
      ],
    },
    {
      heading: 'Ongoing improvements',
      body: [
        'We audit the site regularly for color contrast, keyboard navigation, screen reader compatibility and alt-text on imagery. If you encounter an accessibility barrier, please let us know so we can address it quickly.',
      ],
    },
    {
      heading: 'Contact',
      body: [
        'Report accessibility issues by emailing info@wholesome360.com or calling 773-857-0230. We aim to respond within 2 business days.',
      ],
    },
  ],
};
